



























import { Component, Vue, Prop } from 'vue-property-decorator'
import { IListItem } from '@/store/interface/IListItem'
import { TranslateResult } from 'vue-i18n'
import IDefaultQuasarComponentItem from '@/store/interface/IDefaultQuasarComponentItem'

/**
 * Menu List component
 * Renders a list of items containing a radio, label and icon in each list item
 * @prop list - Array containing the objects of type IListItem
 * @prop selectedItemId - Unique value containing the id of the element to be pre selected
 */
@Component({})
export default class RadioList extends Vue {
	@Prop({ default: false })
	private hasIcons!: boolean
	@Prop({ default: false })
	private isIntegrated!: boolean
	@Prop({ required: true })
	private list!: IListItem[]
	@Prop({ default: '' })
	private selectedItemId!: Number | String

	private translatedLabel (el: IDefaultQuasarComponentItem): string | TranslateResult {
		if (el.label.indexOf('.') !== -1) {
			return this.$t(el.label)
		} else {
			return el.label
		}
	}

	private getIconName (id: string): string {
		return this.hasIcons ? `[ i-${id} ]` : ''
	}

	private selectedLabelStyle (id: string): string {
		return this.selectedItemId !== id ? '' : 'text-accent  text-bold'
	}

	private selectedIconColor (id: string): string {
		return this.selectedItemId !== id ? 'primary' : 'accent'
	}
}
